import { Link } from 'react-router-dom';
import '../assets/styles/Header.css';

function Header() {
  return (
    <header className="sticky-top bg-white shadow-sm">
      <div className="bg-dark text-white py-2">
        <div className="container d-flex justify-content-between align-items-center flex-wrap gap-3">
          <div className="d-flex align-items-center gap-3">
            <a
              href="mailto:mhareed@rffcargo.co.ke"
              className="text-white text-decoration-none d-flex align-items-center gap-2"
              aria-label="Email RFF Cargo"
            >
              <i className="bi bi-envelope fs-6"></i>
              <span>mhareed@rffcargo.co.ke</span>
            </a>
            <a
              href="tel:+254725222600"
              className="text-white text-decoration-none d-flex align-items-center gap-2"
              aria-label="Call RFF Cargo"
            >
              <i className="bi bi-telephone fs-6"></i>
              <span>+254 725 222 600</span>
            </a>
          </div>
          <div className="d-flex gap-3">
            <a
              href="https://www.facebook.com/rffcargo" // Replace with actual profile
              target="_blank"
              rel="noopener noreferrer"
              className="text-white social-icon"
              aria-label="Visit RFF Cargo on Facebook"
            >
              <i className="bi bi-facebook fs-6"></i>
            </a>
            <a
              href="https://x.com/rffcargo" // Replace with actual profile
              target="_blank"
              rel="noopener noreferrer"
              className="text-white social-icon"
              aria-label="Visit RFF Cargo on X"
            >
              <i className="bi bi-twitter-x fs-6"></i>
            </a>
            <a
              href="https://www.linkedin.com/company/rffcargo" // Replace with actual profile
              target="_blank"
              rel="noopener noreferrer"
              className="text-white social-icon"
              aria-label="Visit RFF Cargo on LinkedIn"
            >
              <i className="bi bi-linkedin fs-6"></i>
            </a>
          </div>
        </div>
      </div>
      <nav className="navbar navbar-expand-lg navbar-light bg-white">
        <div className="container">
          <Link
            className="navbar-brand"
            to="/"
            aria-label="RFF Cargo Home"
          >
            <img
              src="/assets/images/rffcargologo.png"
              alt="RFF Cargo Logo"
              className="img-fluid"
              style={{ height: '35px' }}
            />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto align-items-center">
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/"
                  aria-label="Home"
                >
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/about"
                  aria-label="About Us"
                >
                  About Us
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/our-team"
                  aria-label="Our Team"
                >
                  Our Team
                </Link>
              </li>
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  aria-label="Services Menu"
                >
                  Services
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/services/ocean-freight"
                      aria-label="Ocean Freight"
                    >
                      Ocean Freight
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/services/air-freight"
                      aria-label="Air Freight"
                    >
                      Air Freight
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/services/cargo-express"
                      aria-label="Cargo Express"
                    >
                      Cargo Express
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/services/logistics"
                      aria-label="Logistics"
                    >
                      Logistics
                    </Link>
                  </li>
                  <li>
                    <Link
                      className="dropdown-item"
                      to="/services/warehousing"
                      aria-label="Warehousing"
                    >
                      Warehousing
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/gallery"
                  aria-label="Gallery"
                >
                  Gallery
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/contact"
                  aria-label="Contact"
                >
                  Contact
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link btn btn-quote text-white px-3 py-1 ms-3"
                  to="/get-a-quote"
                  aria-label="Get a Quote"
                >
                  Get a Quote
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link btn btn-track text-white px-3 py-1 ms-3"
                  to="/track-shipment"
                  aria-label="Track Shipment"
                >
                  Track Shipment
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;